export function normalizeVersion(version) {
  return (version || "").trim().toLowerCase();
}

export function isTrustedRemoteVersion(version) {
  const normalized = normalizeVersion(version);
  return !!normalized && normalized !== "dev";
}

function parseVersionParts(version) {
  const cleaned = (version || "").trim().replace(/^[vV]/, "");
  return cleaned.split(".").map((part) => {
    const parsed = parseInt(part, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  });
}

export function compareVersions(left, right) {
  const leftParts = parseVersionParts(left);
  const rightParts = parseVersionParts(right);
  const length = Math.max(leftParts.length, rightParts.length);

  for (let index = 0; index < length; index += 1) {
    const diff = (leftParts[index] || 0) - (rightParts[index] || 0);
    if (diff !== 0) {
      return diff;
    }
  }

  return 0;
}

export function isRemoteVersionNewer(remoteVersion, currentVersion) {
  if (!isTrustedRemoteVersion(remoteVersion) || !currentVersion) {
    return false;
  }

  return compareVersions(remoteVersion, currentVersion) > 0;
}

export function isClientUpdateAvailable({
  remoteVersion,
  remoteBuildId,
  currentVersion,
  currentBuildId,
} = {}) {
  const remoteId = normalizeVersion(remoteBuildId);
  const currentId = normalizeVersion(currentBuildId);

  if (remoteId === "dev" || currentId === "dev") return false;

  if (remoteId && currentId) {
    return remoteId !== currentId;
  }

  return isRemoteVersionNewer(remoteVersion, currentVersion);
}
